import { vendorNavPages } from "components/VendorRfi/VendorNav";
import { useAppSelector } from "hooks/redux";
import { filter } from "lodash";
import { useLayoutEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { selectRfi } from "store/rfiSlice";
import { elementTypes, fieldTypes, sectionNames } from "types/RfiTypes";

interface IRfiPreviewNavProps {
  selectedPage: number;
  setSelectedPage?: any;
}

const RfiPreviewNav = (props: IRfiPreviewNavProps) => {
  //states
  const [navHeight, setNavHeight] = useState(0);
  const [selectedSection, setSelectedSection] = useState("");

  //use effects
  useLayoutEffect(() => {
    const nav = document.getElementById("preview-navbar")?.clientHeight;
    if (nav) {
      setNavHeight(nav);
    }
  }, []);

  const rfi = useAppSelector(selectRfi);

  const detailSections = filter(rfi.describe, (e: any) => {
    const eSections = e.sections.find((s: any) => {
      return s.sectionGroupName === sectionNames.DESCRIBE;
    });
    return eSections?.sectionGroupName === sectionNames.DESCRIBE;
  }).filter((element: any) => {
    return (
      element.elementType === elementTypes.FIELD &&
      element.fieldType === fieldTypes.SECTIONHEADER
    );
  });

  const questionnaireSections = filter(rfi.questionnaire, (e: any) => {
    const eSections = e.sections.find((s: any) => {
      return s.sectionGroupName === sectionNames.QUESTIONNAIRE;
    });
    return eSections?.sectionGroupName === sectionNames.QUESTIONNAIRE;
  }).filter((element: any) => {
    return (
      element.elementType === elementTypes.SURVEY &&
      element.fieldType === fieldTypes.SECTIONHEADER
    );
  });

  return (
    <>
      <div
        className="rfi-nav nav flex-column nav-pills sticky-top"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
        style={{ top: navHeight }}
      >
        <div className="nav-box selected">
          <div className="d-flex">
            <h2 className="h5">RFI Package</h2>
          </div>

          <ul className="list-unstyled pl-4 mt-1 mb-0 d-none d-md-block">
            <li className="list-pointer">
              <HashLink
                onClick={() => {
                  props.setSelectedPage(vendorNavPages.UNAUTH_DETAILS);
                  setSelectedSection(`0`);
                }}
                smooth
                to="#top"
              >
                <span
                  className={
                    props.selectedPage === vendorNavPages.UNAUTH_DETAILS
                      ? "selected"
                      : ""
                  }
                >
                  Details
                </span>
              </HashLink>
            </li>
            <li>
              <ul>
                {detailSections.map((element: any, i: number) => {
                  return (
                    <li className="list-pointer" key={i}>
                      <HashLink
                        onClick={() => {
                          props.setSelectedPage(vendorNavPages.UNAUTH_DETAILS);
                          setSelectedSection(`${element.elementId}`);
                        }}
                        smooth
                        to={`#section-${element.elementId}`}
                        scroll={(el) => {
                          //console.log("el", el);
                          el.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          });
                        }}
                      >
                        {" "}
                        <span
                          className={
                            props.selectedPage === 1 &&
                            selectedSection === `${element.elementId}`
                              ? "selected"
                              : ""
                          }
                        >
                          {element.fieldLabel}
                        </span>
                      </HashLink>
                    </li>
                  );
                })}
              </ul>
            </li>
            <li className="list-pointer">
              <HashLink
                to={`#`}
                onClick={() =>
                  props.setSelectedPage(vendorNavPages.UNAUTH_ATTACHMENTS)
                }
              >
                <span
                  className={
                    props.selectedPage === vendorNavPages.UNAUTH_ATTACHMENTS
                      ? "selected"
                      : ""
                  }
                >
                  Attachments
                </span>
              </HashLink>
            </li>
            <li className="list-pointer">
              <HashLink
                to={`#`}
                onClick={() =>
                  props.setSelectedPage(vendorNavPages.UNAUTH_QUESTIONNAIRE)
                }
              >
                <span
                  className={
                    props.selectedPage === vendorNavPages.UNAUTH_QUESTIONNAIRE
                      ? "selected"
                      : ""
                  }
                >
                  Questionnaire
                </span>
              </HashLink>
            </li>
            <li className="list-pointer">
              <HashLink
                to={`#`}
                onClick={() => props.setSelectedPage(vendorNavPages.QA)}
              >
                <span
                  className={
                    props.selectedPage === vendorNavPages.QA ? "selected" : ""
                  }
                >
                  Q&A
                </span>
              </HashLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default RfiPreviewNav;
